<template>
  <div class="">
    <c-details></c-details>
  </div>
</template>

<script>
import CDetails from "@/components/communication/details/index.vue";
import { mapActions } from "vuex";

export default {
  props: {
    msg: String,
  },
  components: {
    CDetails,
  },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({
      text: "Dettagli",
      path: "communication_details",
      level: 1,
    });
  },
};
</script>
